export default "__VITE_ASSET__CDJTetlh__"